import {
  getAccessRolesAsync,
  getAccessRoleDetailAsync,
  updateRoleAccessRightsAsync,
} from "State/AccessRoles/AccessRolesReducer";
import { put, takeLatest } from "redux-saga/effects";
import { getType } from "typesafe-actions";
import {
  postAccessRolesGetList,
  getAccessRolesGetDetail,
  putAccessRolesUpdateAccessRights,
} from "Api/Api";
import { call } from "typed-redux-saga";
import { getResourcePath, Resources } from "Translations/Resources";
import { toast } from "react-toastify";
import i18next from "i18next";

function* getAccessRoles(
  action: ReturnType<typeof getAccessRolesAsync.request>,
): Generator {
  try {
    const response = yield* call(postAccessRolesGetList, action.payload);
    if (response.status === 200) {
      yield put(getAccessRolesAsync.success(response.json));
    } else {
      yield put(getAccessRolesAsync.failure(new Error()));
    }
  } catch (err) {
    yield put(getAccessRolesAsync.failure(err));
  }
}
export function* getAccessRolesSaga() {
  yield takeLatest(getType(getAccessRolesAsync.request), getAccessRoles);
}

function* getAccessRoleDetail(
  action: ReturnType<typeof getAccessRoleDetailAsync.request>,
): Generator {
  try {
    const response = yield* call(getAccessRolesGetDetail, action.payload);
    if (response.status === 200) {
      yield put(getAccessRoleDetailAsync.success(response.json));
    } else {
      yield put(getAccessRoleDetailAsync.failure(new Error()));
    }
  } catch (err) {
    yield put(getAccessRoleDetailAsync.failure(err));
  }
}
export function* getAccessRoleDetailSaga() {
  yield takeLatest(
    getType(getAccessRoleDetailAsync.request),
    getAccessRoleDetail,
  );
}

function* updateAccessRoleAccessRights(
  action: ReturnType<typeof updateRoleAccessRightsAsync.request>,
): Generator {
  try {
    const response = yield* call(
      putAccessRolesUpdateAccessRights,
      action.payload,
    );
    if (response.status === 200) {
      toast.success(
        i18next.t(getResourcePath(Resources.AccessRoles.Detail.SaveSuccess)),
      );
      yield put(updateRoleAccessRightsAsync.success(response.json));
    } else {
      toast.error(
        i18next.t(getResourcePath(Resources.AccessRoles.Detail.SaveFail)),
      );
      yield put(updateRoleAccessRightsAsync.failure(new Error()));
    }
  } catch (err) {
    yield put(updateRoleAccessRightsAsync.failure(err));
  }
}
export function* updateAccessRoleAccessRightsSaga() {
  yield takeLatest(
    getType(updateRoleAccessRightsAsync.request),
    updateAccessRoleAccessRights,
  );
}
